import { render, staticRenderFns } from "./VehicleCostMonthlyReports.vue?vue&type=template&id=1795d8c2&scoped=true"
import script from "./VehicleCostMonthlyReports.vue?vue&type=script&lang=ts"
export * from "./VehicleCostMonthlyReports.vue?vue&type=script&lang=ts"
import style0 from "./VehicleCostMonthlyReports.vue?vue&type=style&index=0&id=1795d8c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1795d8c2",
  null
  
)

export default component.exports